import React from "react"
import S from "./style"
import oki from "../Menu/images/oki.jpg"

const About = () => {
    return(
        <S.Container1>
            <S.Overlay></S.Overlay>
            <S.Container2>
                <S.TextContainer>
                    <S.Title>About Us</S.Title>
                    <S.About>Sushi Gallery is a family owned restaurant that has been in business for over 15 years. Here at Sushi Gallery, we pride ourselves in being able to present you with sushi and rolls nothing less than delicious and fresh all at an affordable price. We welcome you to join us to experience great quality food as well as great quality service. <br/> <br/>-The Chang family</S.About>
                </S.TextContainer>
                <S.Picture src={oki}></S.Picture>
            </S.Container2>
        </S.Container1>
    )
}

export default About